export default "__VITE_ASSET__CXUW3qdZ__"